import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import './network-form.scss';
import { FormLayout } from 'components/FormLayout';
import FieldDesc from 'components/FieldDesc';

type Props = {
  template: FormTemplate,
  data: Partial<types.DeliveryFunctionNetworkInterface>
  onFieldUpdate?: (param: FieldUpdateHandlerParam) => void
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => types.DeliveryFunctionNetworkInterface
}

export const NEWORK_FORM_I18N_KEY = 'network.form';

export const NetworkForm = forwardRef<Ref, Props>(({
  template,
  data,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const mainRef = useRef<Form>(null);

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isMainValid;
  };

  const getValues = () => {
    const {
      networkIdHint,
      ...values
    } = mainRef.current?.getValues();

    const formValues: types.DeliveryFunctionNetworkInterface = {
      ...values,
    };

    return formValues;
  };

  const customFieldComponentMap = {
    networkIdHint: FieldDesc,
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  return (
    <div className="network-form" data-testid="NetworkForm">
      <FormLayout>
        <Form
          ref={mainRef}
          name={template.formId ?? template.key}
          defaults={data}
          fields={(template.main as FormTemplateSection).fields}
          layout={(template.main as FormTemplateSection).metadata.layout?.rows}
          fieldUpdateHandler={onFieldUpdate}
          customFieldComponentMap={customFieldComponentMap}
          i18nKeyPrefix={NEWORK_FORM_I18N_KEY}
        />
      </FormLayout>
    </div>
  );
});

export default NetworkForm;
